export class ConfirmRegistration {
    id: string;
    token: string;
}
